SNI.Application.addModule('recipe-summary', (context) => {

  return {
    behaviors: ['truncate']
  };

});
